// extracted by mini-css-extract-plugin
module.exports = {"menu":"MoreOptions_menu__2ZdeG","settings":"MoreOptions_settings__1qwzd","settings_button":"MoreOptions_settings_button__2YU2Y"};